import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA, MdOption } from '@angular/material';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { BaseService } from '../../../shared/services/base.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { CentreManagementFeeModel } from '../../../models/master-data/centre-management-fee.model';
import { CentreManagementFeeService } from './centre-management-fees.service';
import { DialogService } from '../../../shared/services/dialog.service';

@Component({
    selector: 'modify-centre-management-fees-popup',
    templateUrl: 'modify-centre-management-fees-popup.component.html',
    providers: [CentreManagementFeeService]
})

export class ModifyCentreManagementFeesComponent implements OnInit {
    title: string;
    modifyCentreManagementFeesForm: FormGroup;
    centreManagementFeesModel = new CentreManagementFeeModel();
    formMessage = '';
    id: any;
    centre: any;
    public isSuccess = false;
    centres = JSON.parse(localStorage.getItem(AppConstants.localStorage.centres));
    currentCentreId = localStorage.getItem(AppConstants.localStorage.centreId);
    selectAll = {centreId: '00000000-0000-0000-0000-000000000000', centreName: 'Apply to all'}
    @ViewChild('allSelected') public allSelected: MdOption;

    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public utility: Utility,
        private centreManagementFeeService: CentreManagementFeeService,
        public dialogRef: MdDialogRef<ModifyCentreManagementFeesComponent>,
        public dialogService: DialogService,
        @Inject(MD_DIALOG_DATA) public data: any) {
        this.createForm();
    }

    ngOnInit() {
        this.id = this.data.id;
        this.centre = {
            id: this.data.centreId,
            name: this.data.centreName
        };
        this.getCentreManagementFee(this.id);
        this.title = 'Update Centre Management Fee';
    }

    createForm() {
        this.modifyCentreManagementFeesForm = this.formBuilder.group({
            description: ['', [Validators.required]],
            rate: '',
            centreId: '',
            centreName: '',
            centreIds: ['', [Validators.required]],
            rateId: ['']
        });

    }

    tosslePerOne() {
      if (this.allSelected.selected) {
        this.allSelected.deselect();
        let updatedValues = this.modifyCentreManagementFeesForm.controls.centreIds.value.filter(value => value !== this.selectAll.centreId);
        this.modifyCentreManagementFeesForm.controls.centreIds.setValue(updatedValues);
        return false;
      }
      if (this.modifyCentreManagementFeesForm.controls.centreIds.value.length == this.centres.length)
      {
        this.allSelected.select();
        let currentValues = this.modifyCentreManagementFeesForm.controls.centreIds.value;
        let updatedValues = [...currentValues, this.selectAll.centreId];
        this.modifyCentreManagementFeesForm.controls.centreIds.setValue(updatedValues);
      }
    }
    toggleAllSelection() {
      if (this.allSelected.selected) {
          this.modifyCentreManagementFeesForm.controls.centreIds.patchValue([...this.centres.map(item => item.centreId), this.selectAll.centreId]);
        } else {
            this.modifyCentreManagementFeesForm.controls.centreIds.patchValue([]);
        }
    }

    close() {
        this.dialogRef.close(this.isSuccess);
    }

    getCentreManagementFee(id) {
        this.centreManagementFeeService.getCentreManagementFee(id).subscribe(
            (result) => {
                const data = result.json();
                this.centreManagementFeesModel = data;
                this.centreManagementFeesModel.centreIds = [this.currentCentreId];
            }, (error) => { }
        );
    }

    onSubmit() {
      if(this.modifyCentreManagementFeesForm.valid)
      {
        if (this.modifyCentreManagementFeesForm.value.rate < 0 || this.modifyCentreManagementFeesForm.value.rate > 100)
        this.dialogService.openErrorDialog({ message: AppMessages.centremanagementfee.errorRate})
        else{
          this.centreManagementFeeService.updateCentreManagementFee(this.data.id, this.modifyCentreManagementFeesForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    this.isSuccess = true;
                    this.close();
                }
            }
          )
        }
      }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/centre-management-fees/modify-centre-management-fees-popup.component.ts